module.exports = __webpack_public_path__ + "8b890d6529dfdecaf2daae4e5ce9f36d.png";